'use client';

import { useEffect } from 'react';

interface PlayerTheme {
  primaryColor?: string;
  accentColor?: string;
  backgroundColor?: string;
  textColor?: string;
  borderRadius?: string;
  fontFamily?: string;
  sidebarPosition?: 'left' | 'right';
  showBranding?: boolean;
  logoUrl?: string;
  customCss?: string;
}

export function ThemeProvider({ metadata }: { metadata?: Record<string, any> }) {
  useEffect(() => {
    const theme: PlayerTheme = metadata?.playerTheme || {};
    const root = document.documentElement;

    if (theme.primaryColor) root.style.setProperty('--c3d-primary', theme.primaryColor);
    if (theme.accentColor) root.style.setProperty('--c3d-accent', theme.accentColor);
    if (theme.backgroundColor) root.style.setProperty('--c3d-bg', theme.backgroundColor);
    if (theme.textColor) root.style.setProperty('--c3d-text', theme.textColor);
    if (theme.borderRadius) root.style.setProperty('--c3d-radius', theme.borderRadius);
    if (theme.fontFamily) root.style.setProperty('--c3d-font', theme.fontFamily);

    if (theme.customCss) {
      let styleEl = document.getElementById('c3d-custom-theme');
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'c3d-custom-theme';
        document.head.appendChild(styleEl);
      }
      styleEl.textContent = theme.customCss;
    }

    return () => {
      root.style.removeProperty('--c3d-primary');
      root.style.removeProperty('--c3d-accent');
      root.style.removeProperty('--c3d-bg');
      root.style.removeProperty('--c3d-text');
      root.style.removeProperty('--c3d-radius');
      root.style.removeProperty('--c3d-font');
      const styleEl = document.getElementById('c3d-custom-theme');
      if (styleEl) styleEl.remove();
    };
  }, [metadata]);

  return null;
}

export function usePlayerTheme(metadata?: Record<string, any>): {
  sidebarPosition: 'left' | 'right';
  showBranding: boolean;
  logoUrl: string | null;
} {
  const theme = metadata?.playerTheme || {};
  return {
    sidebarPosition: theme.sidebarPosition || 'right',
    showBranding: theme.showBranding !== false,
    logoUrl: theme.logoUrl || null,
  };
}
